import { Platform } from '@/types/platform';

/**
 * 블라인드 신청 모달 스텝 (전체 플랫폼 통합)
 *
 * BAEMIN: request → confetti → copyInfo
 * CPEATS: request → caution → businessConfirm → confetti → complete
 */
export type BlindStep =
  | 'request'
  | 'confetti'
  | 'copyInfo'
  | 'businessConfirm'
  | 'caution'
  | 'complete';

type BlindFlowConfig = {
  /** 순서대로 표시할 스텝 목록 */
  steps: BlindStep[];
  /** API 호출이 발생하는 스텝 (이 스텝에서 확인 시 신청 API 호출) */
  submitStep: BlindStep;
  /** 중간 이탈 시 확인 Alert 표시 여부 */
  confirmOnExit: boolean;
  /** 리뷰 내용 필수 여부 (true면 내용 없는 리뷰에서 신청 차단) */
  requireContent: boolean;
};

/**
 * 플랫폼별 블라인드 신청 플로우 설정
 *
 * AFFiNE의 Component Registry 패턴 적용:
 * - 삼항연산자/if-else 없이 config lookup으로 플랫폼별 분기
 * - 새 플랫폼 추가 시 이 config에 항목만 추가하면 됨
 */
const BLIND_FLOW = {
  BAEMIN: {
    steps: ['request', 'confetti', 'copyInfo'],
    submitStep: 'request',
    confirmOnExit: false,
    requireContent: false,
  },
  CPEATS: {
    steps: ['request', 'caution', 'businessConfirm', 'confetti', 'complete'],
    submitStep: 'businessConfirm',
    confirmOnExit: true,
    requireContent: true,
  },
} satisfies Record<string, BlindFlowConfig>;

/** 기본 플로우 (매핑 없는 플랫폼은 배민 플로우 사용) */
const DEFAULT_FLOW = BLIND_FLOW.BAEMIN;

/** 플랫폼에 해당하는 블라인드 플로우 반환 */
export const getBlindFlow = (platform?: Platform): BlindFlowConfig => {
  if (!platform) return DEFAULT_FLOW;
  return BLIND_FLOW[platform as keyof typeof BLIND_FLOW] ?? DEFAULT_FLOW;
};
